export default {
    title: "Catalogus",
    noAvailableItems: "Geen producten beschikbaar om te bestellen."
}